import './LandContactPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Space, Image, ConfigProvider } from 'antd'
import { PhoneOutlined, MailOutlined, WechatOutlined } from '@ant-design/icons'
import zhCN from 'antd/es/locale/zh_CN' // 引入中文语言包
import SalesQrCode from '../../images/company/sales_qrcode.jpg'
import SupportQrCode from '../../images/company/support_qrcode.jpg'
import LandBottomLayout from '../common/LandBottomLayout'

export default class LandContactPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="LandContactPage">
          <div className="LandContactPageTitle">{'商务负责人'}</div>
          <div className="LandContactPageWrapper">
            <Space style={{ marginTop: 30 }}>
              <PhoneOutlined style={{ fontSize: 18 }} />
              <div className="LandContactPageMethod">电话</div>
            </Space>
            <div className="LandContactPageContent">17625997856</div>
            <Space style={{ marginTop: 30 }}>
              <MailOutlined style={{ fontSize: 18 }} />
              <div className="LandContactPageMethod">邮箱</div>
            </Space>
            <div className="LandContactPageContent">
              sales@keystridevalve.com
            </div>
            <Space style={{ marginTop: 30 }}>
              <WechatOutlined style={{ fontSize: 18 }} />
              <div className="LandContactPageMethod">
                微信（请扫下方二维码，可点击放大）
              </div>
            </Space>
            <ConfigProvider locale={zhCN}>
              <Image
                src={SalesQrCode}
                width={200}
                preview={{ src: SalesQrCode, mask: null }}
                style={{ cursor: 'pointer', marginTop: 15, marginBottom: 15 }}
              />
            </ConfigProvider>
          </div>

          <div className="LandContactPageTitle">{'技术负责人'}</div>
          <div className="LandContactPageWrapper">
            <Space style={{ marginTop: 30 }}>
              <PhoneOutlined style={{ fontSize: 18 }} />
              <div className="LandContactPageMethod">电话</div>
            </Space>
            <div className="LandContactPageContent">13905285116</div>
            <Space style={{ marginTop: 30 }}>
              <MailOutlined style={{ fontSize: 18 }} />
              <div className="LandContactPageMethod">邮箱</div>
            </Space>
            <div className="LandContactPageContent">
              supportmaster@keystridevalve.com
            </div>
            <Space style={{ marginTop: 30 }}>
              <WechatOutlined style={{ fontSize: 18 }} />
              <div className="LandContactPageMethod">
                微信（请扫下方二维码，可点击放大）
              </div>
            </Space>
            <ConfigProvider locale={zhCN}>
              <Image
                src={SupportQrCode}
                width={200}
                preview={{ src: SupportQrCode, mask: null }}
                style={{ cursor: 'pointer', marginTop: 15, marginBottom: 15 }}
              />
            </ConfigProvider>
          </div>

          <div style={{ height: 30 }} />
        </div>

        <LandBottomLayout {...this.props} />
      </div>
    )
  }
}
